<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="7"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $t($route.meta.pageTitle) }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/dashboard">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ $t(item.text) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right - Last Login Time -->
    <b-col
      class="content-header-right text-md-right mb-2 d-none d-md-block"
      cols="12"
      md="5"
    >
      <span
        v-if="lastLoginDate"
        class="font-small-3"
      >
        <feather-icon
          icon="ClockIcon"
          size="14"
          class="mr-50"
        />
        {{ $t('Your last login time was') }} : {{ lastLoginDate }}
      </span>
    </b-col>
  </b-row>

</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem,
  BCol,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import { toDateWithCustomTime } from '@/helpers/formatDate'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    lastLoginDate() {
      if (this.userData && this.userData.lastLoginDate) {
        return toDateWithCustomTime(this.userData.lastLoginDate)
      }
      return null
    },
  },
}
</script>
